module.exports = __webpack_public_path__ + "img/wx.4c8055d7.png";